export const showNotificationBar = true;
export const notificationText = "Join our Newsletter!";
export const notificationCTA = {
    text: "",
    href: "/newsletter",
}; 